import { apiSlice } from "./apiSlice";

const TODOS_URL = "/api/todos";

export const todoApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // =========================
    // FAVORITES - GET
    // =========================
    getsTodos: builder.query({
      query: () => ({
        url: `${TODOS_URL}/`,
      }),

      providesTags: ["Favorite"],
    }),

    // =========================
    // FAVORITES - ADD
    // =========================
    addsTodo: builder.mutation({
      query: (todo) => ({
        url: `${TODOS_URL}/`,
        method: "POST",
        body: todo,
      }),

      invalidatesTags: ["Favorite"],
    }),

    // =========================
    // FAVORITES - DELETE
    // =========================
    deleteeTodo: builder.mutation({
      query: (id) => ({
        url: `${TODOS_URL}/${id}`,
        method: "DELETE",
      }),

      invalidatesTags: ["Favorite"],
    }),
  }),
});

export const {
  useGetsTodosQuery,
  useAddsTodoMutation,
  useDeleteeTodoMutation,
} = todoApiSlice;